import Tippy from '@tippyjs/react';
import { useTranslation } from 'react-i18next';
import { Literal } from '@steelbuy/ts-shared';
import { Icon, IconIdentifier } from '@steelbuy/ui-primitive';
import { CompletenessItems } from '../bulkListingUtil';

export const ListingCompleteness = ({ completenessItems }: { completenessItems: CompletenessItems }) => {
    const { t } = useTranslation(['translation', 'domainModel', 'uiDomain']);

    const { items, completedCount } = completenessItems;

    const completeness = ((completedCount / items.length) * 100).toFixed(0);

    return (
        <Tippy
            duration={0}
            placement="auto"
            popperOptions={{
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: { top: 8, bottom: 8 },
                        },
                    },
                ],
            }}
            content={
                <div className="bulk-listing-table__listing--progress__completed">
                    <div className="bulk-listing-table__listing--progress__completed--header">
                        {t('application.createBulkListing.editListings.completed', {
                            filled: completedCount,
                            total: items.length,
                        })}
                    </div>
                    {items.map((item, rowIndex) => {
                        const label = 'getLabel' in item ? item.getLabel(t) : t(item.label as Literal);
                        return (
                            <div
                                key={`completeness-${rowIndex + 1}-${label}`}
                                className="bulk-listing-table__listing--progress__completed--text"
                            >
                                <div className="bulk-listing-table__listing--progress__completed--text__label">
                                    {label}
                                </div>
                                <div className="bulk-listing-table__listing--progress__completed--text__value">
                                    {item.isComplete ? (
                                        <Icon name={IconIdentifier.OK} />
                                    ) : (
                                        <Icon name={IconIdentifier.CLOSE} />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            }
        >
            <div className="bulk-listing-table__listing--progress-container">
                <div className="bulk-listing-table__listing--progress">
                    <div className="bulk-listing-table__listing--progress__bar" style={{ width: `${completeness}%` }} />
                </div>
            </div>
        </Tippy>
    );
};
